<template>
	<li>
		<div class="hoverable row">
			<div
				:class="{bold: isFolder, notBold: !isFolder}"
				class="col-6"
				@click="toggle">
				<template v-if="isFolder">
					<i v-if="!open" class="fa fa-building"></i>
					<i v-else-if="open" class="fa fa-building-o"></i>
				</template>
				<template v-else>
					<i class="fa fa-building-o"></i>
				</template>
				{{ model ? model.name : '' }}
			</div>
			<b-form-group class="userPermsCheckboxes col-6">
				<b-form-checkbox
					v-model="currentSelectedDepartment"
					:value="model.id"
					:key="'checkboxDepartments'+model.id"
					:name="'checkbox'+model.id"
					inline
				>
					&nbsp;&nbsp;
				</b-form-checkbox>
				<b-form-checkbox
					v-model="currentSelectedTransfer"
					:value="model.id"
					:key="'checkboxTransferDepartments'+model.id"
					:name="'checkboxTransfer'+model.id"
					inline
				>
					&nbsp;&nbsp;
				</b-form-checkbox>
			</b-form-group>
		</div>

		<ul v-show="open" v-if="isFolder">
			<department-tree-for-user
				@depChanged="checkboxEmitDepartment"
				@transferChanged="checkboxEmitTransfer"
				class="item childItem"
				v-for="(childModel, index) in model.children ? model.children : []"
				:key="index + 'depChild'"
				:model="childModel"
				:selectedDepartmentIds="selectedDepartmentIds"
				:selectedTransferDepartmentIds="selectedTransferDepartmentIds">
			</department-tree-for-user>
		</ul>
	</li>
</template>

<script>
	import Vue from 'vue'
	export default {
		name: "DepartmentTreeForUser",
		props: {
			'model': Object,
			'selectedDepartmentIds': Array,
			'selectedTransferDepartmentIds': Array
		},
		data: function () {
			return {
				open: true,
				currentSelectedDepartment: null,
				currentSelectedTransfer: null
			}
		},
		computed: {
			isFolder: function () {
				return this.model ? (this.model.children &&
					this.model.children.length) : ([] && 0)
			}
		},
		watch: {
			'selectedDepartmentIds': {
				handler () {
					let includesDepartment = this.selectedDepartmentIds.includes(this.model.id);
					if (includesDepartment) {
						this.currentSelectedDepartment = this.model.id;
					} else {
						this.currentSelectedDepartment = null
					}
				}
			},
			'selectedTransferDepartmentIds': {
				handler () {
					let includesTransfer = this.selectedTransferDepartmentIds.includes(this.model.id);
					if (includesTransfer) {
						this.currentSelectedTransfer = this.model.id;
					} else {
						this.currentSelectedTransfer = null
					}
				}
			},
			'currentSelectedDepartment': {
				handler (newVal, oldVal) {
					this.$emit('depChanged', newVal, oldVal);
				}
			},
			'currentSelectedTransfer': {
				handler (newVal, oldVal) {
					this.$emit('transferChanged', newVal, oldVal);
				}
			}
		},
		methods: {
			toggle: function () {
				if (this.isFolder) {
					this.open = !this.open
				}
			},
			checkboxEmitDepartment (newVal, oldVal) {
				this.$emit('depChanged', newVal, oldVal);
			},
			checkboxEmitTransfer (newVal, oldVal) {
				this.$emit('transferChanged', newVal, oldVal);
			},
		}
	}
</script>

<style scoped lang="scss">
	.childItem .userPermsCheckboxes {
		padding-left: .23em;
	}
	.userPermsCheckboxes.form-group {
		display: inline-block;
		margin-bottom: 0;
	}
	.userPermsCheckboxes.form-group div {
		padding-left: 3rem;
		margin: 8px 0;
		&:last-child {
			padding-left: 7rem;
		}
	}
	ul {
		padding-left: 1.7em !important;
		line-height: 1.5em;
		list-style-type: none;
		ul {
			ul {
				.userPermsCheckboxes.form-group div {
					padding-left: 2.25rem !important;
					&:last-child {
						padding-left: 7rem !important;
					}
				}
				ul {
					.userPermsCheckboxes.form-group div {
						padding-left: 1.5rem !important;
						&:last-child {
							padding-left: 7rem !important;
						}
					}
					ul {
						.userPermsCheckboxes.form-group div {
							padding-left: .75rem !important;
							&:last-child {
								padding-left: 7rem !important;
							}
						}
					}
				}
			}
		}
	}
	li div div:first-child, .add, .delete, .edit {
		display: inline-block;
		cursor: pointer;
		margin: 8px 0;
	}
	li div div:first-child {
		&:hover {
			text-decoration: underline;
		}
		word-break: break-all;
	}
	li .bold {
		font-weight: bold;
	}
	.fa {
		margin-right: .8em;
	}
	.fa-building, .fa-building-o {
		color: #F0D45F;
	}

</style>
